var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 8.467 8.467",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.12.266a.8.8 0 0 0-.796.794v1.324H.53c-.361-.008-.361.539 0 .53h.794v1.061H.53c-.361-.008-.361.538 0 .53h.794v1.06H.503c-.346.026-.319.54.027.53h.794V7.42a.8.8 0 0 0 .797.796H7.42a.8.8 0 0 0 .794-.796v-.53c.035-.385-.563-.385-.528 0v.53a.26.26 0 0 1-.266.266h-5.3a.26.26 0 0 1-.266-.266V1.06a.26.26 0 0 1 .267-.266H7.42a.26.26 0 0 1 .266.266v3.709c-.035.385.563.385.528 0V1.06A.797.797 0 0 0 7.42.266zM4.77 1.324a1.33 1.33 0 0 0-1.324 1.327c0 .338.132.644.342.878-.507.186-.873.67-.873 1.24 0 .354.531.354.531 0 0-.445.349-.794.794-.794h1.06c.445 0 .797.349.797.794.007.346.522.346.53 0 0-.57-.367-1.053-.874-1.24.21-.234.344-.54.344-.878 0-.73-.598-1.327-1.327-1.327zm0 .53c.442 0 .797.354.797.797a.792.792 0 0 1-.797.794.79.79 0 0 1-.794-.794c0-.443.352-.797.794-.797zM3.154 5.565c-.346.026-.319.54.027.53h3.178c.362.009.362-.538 0-.53H3.154zm4.796 0a.265.265 0 1 0 0 .53.265.265 0 0 0 0-.53zm-4.266 1.06c-.346.026-.32.541.027.53h2.118c.346-.007.346-.522 0-.53H3.684z",
    paintOrder: "stroke fill markers",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDirectory);
export default __webpack_public_path__ + "static/media/phone-directory.e72027a9e64616fbe205aa643368dce6.svg";
export { ForwardRef as ReactComponent };